"use client";

import dynamic from "next/dynamic";

const TestimonialCarousel = dynamic(() => import("./TestimonialCarousel"), {
  loading: () => <div className="h-20 bg-gray-100 animate-pulse rounded" />,
});

export default TestimonialCarousel;
